<template>
  <!-- Add this modal to your template section -->
  <div
    class="modal fade"
    id="studentParentModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <Modaldiscipline
      :schoolId="schoolId"
      :registrationNumber="selectedRegistrationNumber"
    />
  </div>
  <div
    class="modal fade"
    id="abscenceModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <AbscenceModal :registrationNumber="selectedRegistrationNumber" />
  </div>

  <div
    class="modal fade"
    id="comportementModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <ComportementModal :registrationNumber="selectedRegistrationNumber" />
  </div>

  <!--========================= modal paiement partiel (déclaratif) =================================== -->
  <PartialPaymentModal
    :isVisible="showPartialPayment"
    :student="partialPaymentStudent"
    :payment="partialPaymentInstallment"
    @close="closePartialPaymentModal"
    @payment-recorded="onPartialPaymentRecorded"
  />

  <!--
    Effectifs par âge et par genre. Nourri par la liste déjà chargée : aucun
    appel réseau de plus, et le rapport suit tout ajout ou retrait d'élève.
  -->
  <age-breakdown-modal
    :open="showAgeBreakdown"
    :students="Students"
    :classroom="classroom"
    @close="showAgeBreakdown = false"
  />

  <!--========================= modal change status =================================== -->

  <div
    class="modal fade"
    id="staticBackdrop10"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <Modalpending
      :amount="amount"
      :due_date="due_date"
      :installmentNumber="installmentNumber"
      v-if="show_status"
      :updatestudentstatut="updatestudentstatut"
      :selectedStatus="selectedStatus"
      :updatestatutsettled="updatestatutsettled"
      :close1="close1"
      :selectedStudentsCount="registration_number_list.length"
      :selectedInstallmentId="selectedInstallmentId"
      :selectedStudentName="getSelectedStudentName()"
      :classroomId="classroom_id"
      @confirmed="refreshComponentData"
    />
    <Modalpendingsuccess
      :amount="amount"
      :due_date="due_date"
      v-if="show_sendmessage"
      :installmentNumber="installmentNumber"
      :sendinvoice="sendinvoice"
      :close1="close1"
      :refreshComponentData="refreshComponentData"
    />
    <ModalSuccessSettled v-if="showConfirmation" :close1="close1" />
  </div>

  <div
    class="modal fade"
    id="staticBackdrop11"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <ModalpendingOther
      :paymentDescription="paymentDescription"
      :paymentDate="paymentDate"
      :paymentAmount="paymentAmount"
      v-if="show_status"
      :applyotherstatut="applyotherstatut"
      :selectedStatus="selectedStatus"
      :applyothersettled="applyothersettled"
      :close1="close1"
      :classroomId="classroom_id"
      @confirmed="refreshComponentData"
    />

    <ModalpendingsuccessOther
      :paymentDate="paymentDate"
      :paymentAmount="paymentAmount"
      v-if="show_sendmessage"
      :paymentDescription="paymentDescription"
      :sendinvoiceother="sendinvoiceother"
      :close1="close1"
      :refreshComponentData="refreshComponentData"
    />
    <ModalSuccessSettled v-if="showConfirmation" :close1="close1" />
  </div>

  <!--========================= modal change status other payment =================================== -->

 
  <div
    class="modal fade"
    id="staticBackdrop40"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <ModalCurrent
      :amount="amount"
      :due_date="due_date"
      :installmentNumber="installmentNumber"
      v-if="show_status"
      :updatestudentstatut="updatestudentstatut"
      :selectedStatus="selectedStatus"
      :updatestatutsettled="updatestatutsettled"
      :close1="close1"
      :classroomId="classroom_id"
      @confirmed="refreshComponentData"
    />
  </div>

  <!--========================= modal send alert =================================== -->

  <div
    class="modal fade"
    id="staticBackdrop50"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <NoteModal :gradeCode="gradeCode" :classNumber="classNumber" />
  </div>

  <!--========================= modal sequence alert =================================== -->

  <div
    class="modal fade"
    id="staticBackdrop51"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <SequenceModal />
  </div>

  <!--========================= modal stop course alert =================================== -->

  <div
    class="modal fade"
    id="staticBackdrop52"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <StopcourseModal />
  </div>

  <!--========================= modal promot repeat =================================== -->

  <div
    class="modal fade"
    id="repeatClassModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="repeatClassModalLabel"
    aria-hidden="true"
  >
    <PromoteRepeat
      :registrationNumbers="registration_number_list"
      :loading="loading"
      :classroomId="classroom_id"
      :mode="currentPromotionAction"
      @promotion-success="fetchData"
    />
  </div>

  <!--========================= modal promot  end cycle =================================== -->

  <div
    class="modal fade"
    id="endcycleClassModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="promoteEndcycleModalLabel"
    aria-hidden="true"
  >
  <PromoteEndcycle
    :registrationNumbers="registration_number_list"
    :loading="loading"
    :classroomId="classroom_id"
    @promotion-success="fetchData"
    @cancel="handlePromotionCancel"
  />
  </div>

  <!--========================= modal promot  next =================================== -->

  <div
    class="modal fade"
    id="promoteNextModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="promoteNextModalLabel"
    aria-hidden="true"
  >
    <PromoteNext
      :registrationNumbers="registration_number_list"
      :loading="loading"
      :classroomId="classroom_id"
      @promotion-success="fetchData"
    />
  </div>

  <!--========================= modal promot  demote =================================== -->

  <div
    class="modal fade"
    id="demoteClassModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="demoteClassModalLabel"
    aria-hidden="true"
  >
    <PromoteDemote
      :registrationNumbers="registration_number_list"
      :loading="loading"
      :classroomId="classroom_id"
      @promotion-success="fetchData"
    />
  </div>

  <!--========================= start main =================================== -->
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="row px-0 mb-5">
          <div class="col-md-8">
            <h6 class="mt-2">
              {{ $t("studentlist.student") }} :
              <span class="fs-5 mx-2"
                >{{ studentList.length }} / {{ classroom.student_count }}</span
              >
            </h6>
          </div>
          <div
            class="col-4 pt-3 ps-3 d-flex"
            style="position: relative"
            v-if="Students.length > 0"
          >
            <!------------------------------- Button alert ---------------------------------->

            <div class="dropdown" style="position: absolute; right: 250px">
              <button
                :title="$t('classdetails.button_title')"
                class="btn bg-gradient-success dropdown-toggle"
                id="btn-alerte"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  <i class="text-light bi bi-lightning-charge-fill"></i>
                  <span class="ms-2"> {{ $t("studentlist.alert") }}</span>
                </span>
              </button>
              <ul class="dropdown-menu menu-students p-0">
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop50"
                  class="px-2 dropdown-item"
                >
                  <i class="bi bi-clipboard"></i>
                  <span class="ms-2">{{
                    $t("studentlist.note_available")
                  }}</span>
                </li>
                <li
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop51"
                  class="px-2 dropdown-item"
                >
                  <i class="bi bi-calendar-check"></i>
                  <span class="ms-2">
                    {{ $t("studentlist.sequence_date") }}</span
                  >
                </li>

                <li
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop52"
                  class="px-2 dropdown-item"
                >
                  <i class="bi bi-pause-circle"></i>
                  <span class="ms-2">{{
                    $t("studentlist.course_suspension")
                  }}</span>
                </li>
              </ul>
            </div>

            <!------------------------------- Button new student ---------------------------------->

<div class="dropdown" style="position: absolute; right: 0px">
              <button
                class="btn bg-gradient-success dropdown-toggle btn-alerte"
                id="btn-alerte"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  <span class="fa fa-plus-circle"></span>
                  <span class="ms-2"> {{ $t("button.add_students") }}</span>
                </span>
              </button>

              <ul class="dropdown-menu p-0">
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="{
                      name: 'new-student',
                      params: { classroomId: classroom_id },
                    }"
                  >
                    <i class="bi bi-plus-circle"></i>
                    <span class="ms-2">{{ $t("button.add_student") }} </span>
                  </router-link>
                </li>
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="{
                      name: 'import-students',
                      params: { classroomId: classroom_id },
                    }"
                  >
                    <i class="bi bi-upload"></i>
                    <span class="ms-2">{{ $t("button.import_excel") }} </span>
                  </router-link>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    @click="exportToExcel"
                  >
                    <i class="fas fa-download"></i>
                    <span class="ms-2">{{ $t("button.export_excel") }}</span>
                  </a>
                </li>
              </ul>
            </div>

            <!-------------------------Effectifs par âge---------------------------->
            <!--
              Placé dans le même conteneur que le bouton d'alertes, avec le
              même `right` : l'alignement des deux boutons est ainsi exact par
              construction. Le calculer depuis la rangée du dessous
              obligerait à tenir compte des gouttières de la grille, et se
              décalerait au moindre changement de mise en page.
            -->
            <div class="age-breakdown">
              <button
                :title="$t('age_breakdown.button_title')"
                class="btn bg-gradient-success btn-age-breakdown d-flex align-items-center"
                type="button"
                @click="showAgeBreakdown = true"
              >
                <span>
                  <i class="text-light bi bi-bar-chart-fill me-2"></i>
                  {{ $t("age_breakdown.button") }}
                </span>
              </button>
            </div>
          </div>
        </div>

        <div
          class="d-flex justify-content-between px-0"
          v-if="Students.length > 0"
        >

          <!-------------------------------Select Installment---------------------------------->

          <div
            class="d-flex tabble-buttun"
            v-if="isDropdownVisible"
            style="width: max-content"
            :key="refreshKey"
          >
            <span>
              <div class="d-flex tabble-buttun" v-if="isDropdownVisible">
                <div id="filter">
                  <div class="dropdown" id="dropdown">
                    <button
                      class="btn dropdown-toggle bg-gradient-success text-light d-flex align-items-center"
                      id="btn-alerte"
                      type="button"
                      data-bs-toggle="dropdown"
                      style="transform: translate(-105px, -30px)"
                    >
                      <div class="d-flex align-items-center">
                        <div>
                          <i class="bi bi-pie-chart-fill me-2"></i>
                        </div>
                        <div>{{ $t("studentlist.select_installment") }}</div>
                      </div>
                    </button>
                    <ul class="dropdown-menu" id="dropdown-menu">
                      <li class="li bg-light text-dark fw-bold">
                        {{ $t("sidebar.scolarité") }}
                      </li>

                      <li
                        v-for="obj in configInstallments"
                        :key="obj.id"
                        :title="$t('studentlist.select_title')"
                        class="li"
                        @click="openmodal(obj.installment[0], obj.id)"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop10"
                      >
                        {{ $t("studentlist.installment") }}
                        {{ obj.installment[0].number }} ( {{ currency_code }}
                        {{
                          Number(obj.installment[0].amount).toLocaleString(
                            this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )
                        }}
                        )
                      </li>

                      <li
                        v-if="otherPayments"
                        class="li bg-light text-dark fw-bold"
                      >
                        ≈
                        {{ $t("sidebar.other-payment") }}
                      </li>

                      <li
                        v-for="obj in otherPayments"
                        :key="obj.id"
                        :title="$t('studentlist.select_title')"
                        class="li"
                        @click="openPaymentModal(obj, obj.id)"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop11"
                      >
                        {{ obj.description }} ( {{ currency_code }}
                        {{
                          Number(obj.amount).toLocaleString(
                            this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )
                        }}
                        )
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </span>
          </div>

          <!-------------------------------Promote---------------------------------->
          <div
            class="d-flex tabble-buttun"
            v-if="isDropdownVisible"
            style="width: max-content; margin-right: 10px"
            :key="refreshKey"
          >
            <span>
              <div class="d-flex tabble-buttun" v-if="isDropdownVisible">
                <div id="filter">
                  <div class="dropdown" id="dropdown">
                    <button
                      style="
                        background: #75acff;
                        color: #00182b;
                        transform: translate(-80px, -30px);
                        width: 200px;
                      "
                      class="btn dropdown-toggle d-flex align-items-center"
                      id="btn-alerte"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <span>
                        <i class="bi bi-arrow-up-right-circle me-2"></i>
                        {{ $t("studentlist.promote") }}
                      </span>
                    </button>
                    <ul class="dropdown-menu" id="dropdown-menu">
                      <li
                        class="li"
                        :title="$t('studentlist.promote_title')"
                        data-bs-toggle="modal"
                        data-bs-target="#promoteNextModal"
                        @click="promoteStudents('next')"
                      >
                        <i class="bi bi-arrow-up-circle"></i>
                        {{ $t("studentlist.promote_next") }}
                      </li>
                      <li
                        class="li"
                        :title="$t('studentlist.repeat_title')"
                        data-bs-toggle="modal"
                        data-bs-target="#repeatClassModal"
                        @click="promoteStudents('repeat')"
                      >
                        <i class="bi bi-arrow-repeat"></i>
                        {{ $t("studentlist.repeat_class") }}
                      </li>
                      <li
                        class="li d-flex align-items-center"
                        :title="$t('studentlist.change_class_title')"
                        data-bs-toggle="modal"
                        data-bs-target="#repeatClassModal"
                        @click="promoteStudents('change')"
                      >
                        <i class="bi bi-arrow-left-right me-2" style="transform: translateY(-2px);"></i>
                        {{ $t("studentlist.change_class") }}
                      </li>
                      <li
                        class="li"
                        :title="$t('studentlist.demote_title')"
                        data-bs-toggle="modal"
                        data-bs-target="#demoteClassModal"
                        @click="promoteStudents('previous')"
                      >
                        <i class="bi bi-arrow-down-circle"></i>
                        {{ $t("studentlist.demote") }}
                      </li>
                       <li
                        class="li"
                        :title="$t('studentlist.demote_title')"
                        data-bs-toggle="modal"
                        data-bs-target="#endcycleClassModal"
                        @click="promoteStudents('previous')"
                      >
                        <i class="bi bi-calendar-x"></i>
                        {{ $t("studentlist.endcycle") }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </span>
          </div>

          <!-------------------------Error message---------------------------->

          <div
            class="message d-flex"
            v-if="!isDropdownVisible && !studentsPending.length > 0"
          >
            <i
              style="transform: translateY(-10px)"
              class="bi bi-exclamation-triangle-fill text-warning fs-3"
            ></i>
            <p class="mx-2">
              <span style="font-size: 14px">{{
                $t("studentlist.table_alert")
              }}</span>
            </p>
          </div>

          <!-------------------------button send message---------------------------->

          <div
            class="message"
            v-if="isDropdownVisible && studentsPending.length > 0"
            style="transform: translateY(20px); margin-left: 90px"
          >
            <div
              @click="sendinvoice"
              :disabled="loading"
              title="Envoyer la facture"
            >
              <span v-if="!loading" id="send"
                ><i class="bi bi-send-fill mx-2"></i
              ></span>
              <div
                v-if="loading"
                class="spinner-border spinner-border-sm"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------Loading --------------------------->
    <div class="card-body px-0 pt-0 pb-2 mt-4">
      <div class="d-flex w-100" id="legend" v-if="Students.length > 0">
        <div :title="$t('studentlist.no_statut_title')" class="d-flex mx-3">
          <span id="stat-null"></span>
          <p class="mx-1" style="font-size: 14px; transform: translateY(2px)">
            {{ $t("studentlist.no_statut") }}
          </p>
        </div>
        <div :title="$t('studentlist.pending_title')" class="d-flex mx-3">
          <span class="bg-gradient-warning" id="stat-pending"></span>
          <p class="mx-1" style="font-size: 14px; transform: translateY(2px)">
            {{ $t("studentlist.pending") }}
          </p>
        </div>
        <div :title="$t('studentlist.settled_title')" class="d-flex mx-3">
          <span class="bg-gradient-success" id="stat-settled"></span>
          <p class="mx-1" style="font-size: 14px; transform: translateY(2px)">
            {{ $t("studentlist.settled") }}
          </p>
        </div>
        <div :title="$t('studentlist.overdue_title')" class="d-flex mx-3">
          <span class="bg-gradient-danger" id="stat-settled"></span>
          <p class="mx-1" style="font-size: 14px; transform: translateY(2px)">
            {{ $t("studentlist.overdue") }}
          </p>
        </div>
        <div :title="$t('studentlist.alert_title1')" class="d-flex mx-3">
          <span class="icon-alert-legend">
            <i class="text-light bi bi-lightning-charge-fill"></i>
          </span>
          <p class="mx-1" style="font-size: 14px; transform: translateY(2px)">
            {{ $t("studentlist.notif") }}
          </p>
        </div>
      </div>
      <Spinner
        class="text-center mt-8 mb-8"
        v-if="isInitialLoading"
        style="height: 200px"
      >
        <div>
          <span class="mt-4">
            <Spinner></Spinner>
          </span>
        </div>
      </Spinner>
      <div class="table-responsive" style="z-index: 10" v-else-if="Students.length > 0" :key="refreshKey">
        <table class="table mt-4 align-items-center mb-7">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255, 255, 255, 0.1)">
              <th scope="col" class="text-sm border-0 ps-3 w-5">
                <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleSelectAll"
                />
              </th>
              <th
                class="border-0 text-start text-sm w-25"
                style="transform: translateX(-15px)"
              >
                {{ $t("studentlist.student") }}
              </th>
              <th
                scope="col "
                class="text-sm border-0 w-30 text-start"
                style="width: 120px"
              >
                {{ $t("studentlist.table_matricul") }}
              </th>

              <th scope="col" class="text-sm w-25 border-0 text-start">
                {{ $t("studentlist.schooling") }} ( {{ currency_code }}
                <span v-if="Students.length > 0">
                  {{
                    Number(Students[0].total_due).toLocaleString(
                      this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )
                  }})
                </span>
              </th>

              <th scope="col" class="text-sm text-end border-0 w-25">
                {{ $t("studentlist.other_payment") }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              id="tr-alert"
              v-for="student in paginatedStudents"
              :key="student.id"
              style=" border-bottom: 1px solid rgba(255, 255, 255, 0.1); "
            >
              <td class="border-0 ps-3">
                <input
                  class="border-0"
                  type="checkbox"
                  v-model="student.selected"
                  @change="onCheckboxChange"
                />
              </td>
              <td class="border-0">
                <div class="d-flex py-1 border-0 image-studdents">
                  <div>
                    <router-link
                      v-if="student.registration_number"
                      :to="{
                        name: 'student-details',
                        params: {
                          id: student.id,
                          classroom_id: classroom_id,
                        },
                      }"
                    >
                      <div class="d-flex">
                        <div class="">
                          <div
                            class=""
                            id="avatar"
                            :title="$t('classdetails.photo_title')"
                          >
                            <Zoomableimage :photoUrl="student.photo_url" />
                          </div>
                        </div>
                        <!--
                          Nom de famille en première ligne, prénom en seconde :
                          c'est dans cet ordre qu'on cherche un élève dans une
                          liste de classe.

                          Le nom de famille se lit dans `first_name` : les deux
                          colonnes portent l'inverse de ce qu'elles
                          contiennent. `utils/studentName` porte l'explication
                          et les accesseurs.
                        -->
                        <div class="name ms-2">
                          <span class="mb-0 fs-6">
                            {{ familyNameOf(student) }}
                          </span>

                          <br />
                          <span
                            class="fs-6 text-secondary mb-0"
                            :title="$t('classdetails.photo_title')"
                            >{{ givenNameOf(student) }}</span
                          >
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <span
                    class="badge bg-gradient-success text-xxs align-self-center ms-2"
                    :title="$t('classroom_setup.parent_added_title')"
                    v-if="student.created_by_parent"
                  >
                    ESKA
                  </span>
                  <span
                    class="icon-alert-dash"
                    :title="$t('studentlist.alert_title')"
                    v-if="student.has_subscribe_to_alert"
                  >
                    <i class="text-light bi bi-lightning-charge-fill"></i>
                  </span>
                </div>
              </td>
              <td
                class="text-xs font-weight-bold mb-0 text-start ps-4 text-uppercase border-0"
              >
                {{ student.registration_number }}
              </td>

              <td
                class="d-flex border-0 align-items-center justify-content-start ps-4 w-100"
              >
                <div class="mt-3" style="min-width: 40%" id="see">
                  <div class="d-flex align-items-center justify-content-center">
                    <div
                      class="d-flex align-items-center justify-content-center me-2"
                    >
                      <div
                        class="cicle mx-1"
                        v-for="payment in regularPayments(student)"
                        :key="payment.id"
                      >
                        <div
                          v-if="
                            payment.status === 'Pending' &&
                            payment['is_other_payment'] === false
                          "
                        >
                          <!--
                            Échéance dépassée. Elle portait `cursor-pointer`
                            sans gestionnaire : le curseur annonçait une action
                            qui n'existait pas. C'est pourtant là qu'un
                            versement partiel se saisit le plus souvent.
                          -->
                          <span
                            :title="getPendingTitle(payment)"
                            v-if="isDueDatePast(payment.due_date)"
                            class="span3 bg-gradient-danger cursor-pointer"
                            :class="{ 'span-declarative': declarativeFlowEnabled }"
                            @click.stop="openPartialPaymentModal(student, payment)"
                          ></span>
                          <span
                            :title="getPendingTitle(payment)"
                            v-else
                            class="span2 bg-gradient-warning cursor-pointer"
                            :class="{ 'span-declarative': declarativeFlowEnabled }"
                            @click.stop="openPartialPaymentModal(student, payment)"
                          ></span>
                        </div>

                        <div
                          :title="getSettledTitle(payment)"
                          v-if="
                            payment.status === 'Settled' &&
                            payment.is_other_payment === false
                          "
                          class=""
                        >
                          <span
                            class="bg-gradient-success span1 cursor-pointer"
                          ></span>
                        </div>

                        <div
                          :title="getNoTitle(payment)"
                          v-if="
                            payment['status'] === null &&
                            payment.is_other_payment === false
                          "
                        >
                          <span class="span cursor-pointer"></span>
                        </div>
                      </div>
                    </div>

                    <div class="ms-auto">
                      <span
                        v-if="getOverdueAmount(student) > 0"
                        class="text-xs font-weight-bold"
                        style="color: #ff6a5c !important"
                      >
                        -
                        {{ Number(getOverdueAmount(student)).toLocaleString() }}
                      </span>
                      <span
                        v-else
                        class="text-xs font-weight-bold"
                        style="color: transparent"
                      >
                        -
                        {{ Number(getOverdueAmount(student)).toLocaleString() }}
                      </span>
                    </div>
                  </div>

                </div>
              </td>

              <td class="text-end border-0" id="td-alert">
                <div
                  class="toggle-alert pb"
                  v-if="student.has_subscribe_to_alert"
                >
                  <div
                    class="dropdown-wrapper"
                    style="transform: translateY(-7px)"
                  >
                    <span
                      style="
                        background: #1a98ff;
                        font-size: 13px;
                        border-radius: 5px;
                      "
                      class="px-2 py-1"
                      @click="showParentInfo(student)"
                    >
                      <i
                        class="bg-transparent text-light bi bi-lightning-charge-fill"
                      ></i>
                      Alerts
                    </span>

                    <ul
                      class="dropdown-menu-custom"
                      v-if="
                        selectedStudent && selectedStudent.id === student.id
                      "
                    >
                      <li
                        data-bs-toggle="modal"
                        data-bs-target="#studentParentModal"
                        class="dropdown-item-custom"
                        @click="
                          openConvocationModal(student.registration_number)
                        "
                      >
                        {{ $t("studentlist.convocation") }}
                      </li>

                      <li
                        data-bs-toggle="modal"
                        data-bs-target="#abscenceModal"
                        class="dropdown-item-custom"
                        @click="openAbsenceModal(student.registration_number)"
                      >
                        {{ $t("studentlist.absence") }}
                      </li>

                      <li
                        class="dropdown-item-custom"
                        data-bs-toggle="modal"
                        data-bs-target="#comportementModal"
                        @click="openBehaviorModal(student.registration_number)"
                      >
                        {{ $t("studentlist.follow") }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="mt-3 pe-2"
                  style="min-width: 40%; float: right"
                  id="see"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <div
                      class="d-flex align-items-center justify-content-end"
                      style="gap: 6px"
                    >
                      <div
                        class="cicle mx-1"
                        v-for="payment in otherPayment(student)"
                        :key="payment.id"
                      >
                        <!--
                          Un autre paiement se règle en plusieurs fois comme une
                          tranche de scolarité : ses pastilles ouvrent la même
                          saisie. Elles n'avaient aucun gestionnaire — cliquer
                          dessus ne faisait rien, sans que rien ne l'explique.
                        -->
                        <div
                          v-if="
                            payment.status === 'Pending' &&
                            payment.is_other_payment === true
                          "
                        >
                          <span
                            :title="getPendingTitle(payment)"
                            v-if="isDueDatePast(payment.due_date)"
                            class="span3 bg-gradient-danger cursor-pointer"
                            :class="{ 'span-declarative': declarativeFlowEnabled }"
                            @click.stop="openPartialPaymentModal(student, payment)"
                          ></span>
                          <span
                            :title="getPendingTitle(payment)"
                            v-else
                            class="span2 bg-gradient-warning cursor-pointer"
                            :class="{ 'span-declarative': declarativeFlowEnabled }"
                            @click.stop="openPartialPaymentModal(student, payment)"
                          ></span>
                        </div>
                        <div
                          :title="getSettledTitle(payment)"
                          v-if="
                            payment.status === 'Settled' &&
                            payment.is_other_payment === true
                          "
                        >
                          <span class="bg-gradient-success ms-1 span1"></span>
                        </div>
                        <div
                          :title="getNoTitle(payment)"
                          v-if="
                            payment['status'] === null &&
                            payment.is_other_payment === true
                          "
                        >
                          <span class="span"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr></tr>
          </tbody>
        </table>
        <nav aria-label="...">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button
                class="page-link"
                @click="prevPage"
                :disabled="currentPage === 1"
                style="background: none; color: white"
              >
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              v-for="page in totalPages"
              :key="page"
              class="page-item"
              :class="{ active: currentPage === page }"
            >
              <button
                class="page-link fw-bold"
                style="background: none"
                @click="setCurrentPage(page)"
              >
                {{ page }}
              </button>
            </li>
            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
              <button
                class="page-link"
                @click="nextPage"
                style="background: none; color: white"
                :disabled="currentPage === totalPages"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <div v-else>
        <div class="card empty else" style="transform: translateY(10px)">
          <div class="card-header pb-5">
            <div class="row">
              <div class="container">
                <div class="text text-center" style="margin-top: -70px">
                  <img class="image1" src="@/assets/img/classe.png" alt="" />
                  <h5 class="">{{ $t("studentlist.no_student_title") }}</h5>
                  <p class="mb-3 mt-4">
                    {{ $t("studentlist.no_student_text") }}
                  </p>

                  <div class="center-dropdown">
                  <button
                      class="btn bg-gradient-success dropdown-toggle btn-alerte"
                      id="btn-alerte"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                    <span>
                        <span class="fa fa-plus-circle"></span>
                        <span class="ms-2"> {{ $t("button.add_students") }}</span>
                      </span>
                  </button>
  <ul class="dropdown-menu p-0" style="top: auto; bottom: 100%; left: 0; right: auto; margin-bottom: 5px;">
    <li>
      <router-link
        class="dropdown-item"
        :to="{
          name: 'new-student',
          params: { classroomId: classroom_id },
        }"
      >
        <i class="bi bi-plus-circle"></i>
        <span class="ms-2">{{ $t("button.add_student") }} </span>
      </router-link>
    </li>
    <li>
      <router-link
        class="dropdown-item"
        :to="{
          name: 'import-students',
          params: { classroomId: classroom_id },
        }"
      >
        <i class="bi bi-upload"></i>
        <span class="ms-2">{{ $t("button.import_excel") }} </span>
      </router-link>
    </li>
  </ul>
</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <certificate-generator
    :open="showCertificates"
    :students="certificateStudents"
    :classroom="classroom"
    @close="closeCertificate"
  />
</template>

<script>
import {
  sendinvoice,
  xpayconnection,
  createAndSetPaymentStatus,
} from "@/utils/services";
import apiConfig from "@/config";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Spinner from "../components/Spinner.vue";
import Modalpending from "../modal/ModalPending";
import PartialPaymentModal from "@/views/modal/PartialPaymentModal.vue";
import { isCollaborativeMode, canIssueCertificate } from "@/utils/classroomSetup";
import AgeBreakdownModal from "@/views/Classroom/AgeBreakdownModal.vue";
import {
  familyNameOf,
  givenNameOf,
  sortByFamilyName,
} from "@/utils/studentName";
import CertificateGenerator from "@/views/Classroom/CertificateGenerator.vue";
import ModalpendingOther from "@/views/modal/ModalPending2.vue";
import Modalpendingsuccess from "../modal/ModalPendingSuccess";
import ModalpendingsuccessOther from "@/views/modal/ ModalpendingsuccessOther.vue";
import ModalSuccessSettled from "../modal/ModalSuccessSettled";
import ModalCurrent from "../modal/CurrentModal.vue";
import NoteModal from "../modal/notemodal.vue";
import SequenceModal from "../modal/sequencemodal.vue";
import StopcourseModal from "../modal/stopcoursemodal.vue";
import Modaldiscipline from "../modal/Modaldiscipline.vue";
import AbscenceModal from "../modal/Abscencemodal.vue";
import ComportementModal from "../modal/ComportementModal.vue";
import PromoteRepeat from "../modal/PromoteRepeat.vue";
import PromoteNext from "../modal/PromoteNext.vue";
import PromoteDemote from "../modal/PromoteDemote.vue";
import PromoteEndcycle from "../modal/PromoteEndcycle.vue";
import api_config from "@/config";
import Zoomableimage from "@/views/components/Zoomableimage.vue";
import { studentsProvider } from "@/utils/studentsProvider";
import * as XLSX from "xlsx";

export default {
  name: "student-table",
  components: {
    CertificateGenerator,
    Spinner,
    ModalCurrent,
    Modalpending,
    ModalpendingOther,
    Modalpendingsuccess,
    ModalSuccessSettled,
    ModalpendingsuccessOther,
    NoteModal,
    SequenceModal,
    StopcourseModal,
    Modaldiscipline,
    AbscenceModal,
    ComportementModal,
    Zoomableimage,
    PromoteRepeat,
    PromoteNext,
    PromoteDemote,
    PromoteEndcycle,
    PartialPaymentModal,
    AgeBreakdownModal
  },
  data() {
    return {
      currentPromotionAction: 'repeat',
      selectAll: false,
      isDropdownVisible: false,
      checkboxesChecked: false,
      selectedInstallment: "",
      payment_status: null,
      status: null,
      showPartialPayment: false,
      partialPaymentStudent: null,
      partialPaymentInstallment: null,
      installmentApplied: false,
      isApplyingInstallment: false,
      currentDate: null,
      selectedStatussettled: "Settled",
      classroom: {},
      studentList: [],
      payments: [],
      classroom_id: this.$route.params.classId,
      registration_number_list: [],
      showCertificates: false,
      certificateStudent: null,
      label: "",
      amount: "",
      due_date: "",
      number: "",
      selectedStudent: null,
      schoolId: "",

      school_year: new Date().getFullYear(),
      type: "SchoolFees",
      settled: apiConfig.SETTLED,
      accepted: apiConfig.ACCEPTED,
      overdue: apiConfig.OVERDUE,
      pending: apiConfig.PENDING,
      paid: apiConfig.PAID,
      today: this.getCurrentDate(),
      // Propriétés pour les paiements
      selectedPayment: null,
      selectedPaymentId: null,
      showModalPayments: false,
      noSelectPayment: true,
      studentsPending: [],
      selectedStatus: "Pending",
      show_modal_installments: true,
      show_success_installment: false,
      show_status: true,
      show_sendmessage: false,
      showConfirmation: false,
      refreshKey: 0,
      modalinstallment: false,
      modalpending: false,
      school_slug: apiConfig.SERVICE_NAME,
      isLocal:
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1",
      loading: false,
      isInitialLoading: true,
      currentPage: 1,
      pageSize: 50,
      /* Rapport des effectifs par âge et par genre. */
      showAgeBreakdown: false,
      paymentDescription: "",
      paymentAmount: 0,
      paymentDate: "",
      paymentId: "",
      payment_type: "SchoolFees",
      status_code: "",
      gradeCode: "",
      classNumber: "",
      selectedRegistrationNumber: null,
      selectedStudentId: null,
      currency_code: api_config.CURRENCY_CODE,
      promotionType: null,
    };
  },

  async beforeMount() {
    await this.fetchData();
    setInterval(() => {
      this.fetchData();
    }, 300000);
  },
  mounted() {
    this.$emit("child-data", this.numberOfSettledStudents);

    this.schoolId = localStorage.getItem("schoolId");
    this.fetchxpayconnection();

    // Le panneau du filtre se ferme au clic à côté, comme un menu.
    document.addEventListener("click", this.closeAgeFilterOnOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.closeAgeFilterOnOutsideClick);
  },

  computed: {
    /**
     * Le modal ne reçoit qu'un seul élève : la génération se fait désormais
     * élève par élève, depuis sa ligne dans la liste.
     */
    certificateStudents() {
      return this.certificateStudent ? [this.certificateStudent] : [];
    },
    /** Saisie déclarative de paiement disponible en mode collaboratif ESKA. */
    declarativeFlowEnabled() {
      return isCollaborativeMode();
    },

    Students() {
      // Utilise le provider pour obtenir la liste des étudiants de la classe courante
      const data = studentsProvider.students.get(this.classroom_id);
      return data && data.students ? data.students : [];
    },
    pendingStudents() {
      return studentsProvider.getPendingStudents(this.classroom_id);
    },
    currentPaymentOfFirstPendingStudent() {
      return this.pendingStudents.length > 0
        ? this.pendingStudents[0].current_payment
        : null;
    },
    numberOfSettledStudents() {
      return studentsProvider.getSettledStudents(this.classroom_id).length;
    },
    /**
     * Élèves affichés, classés par nom de famille puis par prénom.
     *
     * Voir `utils/studentName` pour les règles de tri.
     */
    orderedStudents() {
      return sortByFamilyName(this.Students, this.$i18n.locale);
    },
    paginatedStudents() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.orderedStudents.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.orderedStudents.length / this.pageSize);
    },
  },

  watch: {
    pendingStudents: {
      handler() {
        this.updatePendingStudents();
      },
      immediate: true,
    },
    // Watch for route changes to fetch new classroom data
    $route(to, from) {
      if (to.params.classId !== from.params.classId) {
        this.classroom_id = to.params.classId;
        this.isInitialLoading = true; // Remettre à true pour le nouveau chargement
        this.fetchData();
      }
    },
  },

  methods: {
    /* Lecture des noms. Passée par `utils/studentName`, seule à connaître
       l'inversion des deux colonnes. */
    familyNameOf,
    givenNameOf,
    /** Ouvre l'aperçu des certificats pour tous les élèves de la classe. */
    /**
     * Le certificat est-il délivrable à cet élève ?
     * Dépend du réglage « Autoriser les certificats pour tous les élèves » :
     * activé, tous y ont droit ; désactivé, seuls ceux dont les paiements
     * sont réglés.
     */
    canIssue(student) {
      return canIssueCertificate(student);
    },
    openCertificateFor(student) {
      this.certificateStudent = student;
      this.showCertificates = true;
    },
    closeCertificate() {
      this.showCertificates = false;
      this.certificateStudent = null;
    },
    /** Le flux déclaratif (paiement partiel) suit la configuration du module Classroom. */
    /**
     * Ferme le modal de paiement partiel et recharge la liste.
     *
     * Le rafraîchissement va chercher les valeurs réellement enregistrées par
     * le serveur : la mise à jour locale faite à la validation reste une
     * estimation (montants recalculés côté client), et un versement saisi
     * depuis un autre poste ne serait pas visible autrement.
     */
    closePartialPaymentModal() {
      this.showPartialPayment = false;
      this.partialPaymentStudent = null;
      this.partialPaymentInstallment = null;
      this.refreshComponentData();
    },
    openPartialPaymentModal(student, payment) {
      /*
       * La saisie déclarative est réservée au mode collaboratif. Un `return`
       * muet rendait l'absence de réaction impossible à comprendre : on
       * explique désormais pourquoi rien ne s'ouvre.
       */
      if (!this.declarativeFlowEnabled) {
        toast.info(this.$t("partial_payment.collaborative_only"), {
          autoClose: 4000,
        });
        return;
      }
      this.partialPaymentStudent = student;
      this.partialPaymentInstallment = payment;
      this.showPartialPayment = true;
    },

    /** Met à jour le solde de l'élève et la pastille correspondante. */
    onPartialPaymentRecorded(record) {
      const student = this.Students.find((item) => item.id === record.student_id);
      if (!student) return;
      const payment = (student.payments || []).find((item) => item.id === record.payment_id);
      if (!payment) return;

      payment.paid_amount = Number(payment.paid_amount || 0) + Number(record.amount);
      payment.partial_payments = [...(payment.partial_payments || []), record];

      payment.splits = [
        ...(payment.splits || []),
        {
          amount: Number(record.amount),
          on: record.on || new Date().toLocaleDateString(
            this.$i18n.locale === "fr" ? "fr-FR" : "en-US"
          ),
          reference: record.reference || "",
        },
      ];

      const due = Number(payment.amount || payment.due_amount || 0);
      if (due && payment.paid_amount >= due) {
        payment.status = "Settled";
      }
      student.total_paid = Number(student.total_paid || 0) + Number(record.amount);
      this.refreshKey += 1;
    },

    promoteStudents(type) {
      // enregistrer le type d'action pour que le modal sache quel texte/action utiliser
      this.currentPromotionAction = type;
      if (this.registration_number_list.length === 0) {
        toast.error(this.$t("studentlist.no_students_selected"), {
          autoClose: 3000,
        });
        return;
      }
      
      if (type === "next") {
        
        if (this.selectedClassroomId) {
          this.$router.push({ name: "class-details", params: { classId: this.selectedClassroomId } });
        }
      } else if (type === "previous") {
       
        console.warn('promoteStudents: "previous" promotion not implemented');
      } else if (type === "repeat") {
        console.warn('promoteStudents: "repeat" promotion not implemented');
      } else if (type === "change") {
        // action 'change' will be handled by the modal which uses PromoteStudent with action ChangeClassroom
        console.warn('promoteStudents: "change" promotion will open modal');
      }
    },

    
    handlePromotionCancel() {
      
      const modalElement = document.getElementById("endcycleClassModal");
      if (modalElement) {
        const modalInstance = window.bootstrap?.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
     
      this.fetchData();
    },

    openCurrentModal(student, payment) {
      this.selectedStudentId = student.id;
      this.selectedPayment = payment;
      this.amount = payment.amount;
      this.due_date = payment.due_date;
      this.installmentNumber = payment.number;
      this.setSelectedInstallment(payment);
      this.setSelectedPayment(payment);
      this.amount = payment.amount;
      this.due_date = payment.due_date;
      this.installmentNumber = payment.number;
      this.label = payment.label || "";
      this.registration_number_list = [student.registration_number];
      this.show_status = true;
      this.show_sendmessage = false;
      this.showConfirmation = false;
    },

    getOverdueAmount(student) {
      if (!student.payments || !Array.isArray(student.payments)) {
        return 0;
      }
      return student.payments.reduce((total, payment) => {
        if (
          payment &&
          payment.status === "Pending" &&
          !payment.is_other_payment &&
          payment.due_date &&
          this.isDueDatePast(payment.due_date)
        ) {
          const paidAmount = payment.splits
            ? payment.splits.reduce((sum, split) => sum + split.amount, 0)
            : 0;
          const remainingAmount = payment.amount - paidAmount;
          return total + remainingAmount;
        }
        return total;
      }, 0);
    },

    openConvocationModal(registrationNumber) {
      this.selectedRegistrationNumber = registrationNumber;
      this.$emit("convocation-modal", registrationNumber);
    },

    openAbsenceModal(registrationNumber) {
      this.selectedRegistrationNumber = registrationNumber;
      this.$emit("absence-modal", registrationNumber);
    },

    openBehaviorModal(registrationNumber) {
      this.selectedRegistrationNumber = registrationNumber;
      this.$emit("behavior-modal", registrationNumber);
    },

    showParentInfo(student) {
      if (this.selectedStudent && this.selectedStudent.id === student.id) {
        this.selectedStudent = null;
      } else {
        this.selectedStudent = student;
      }
    },

    async fetchData() {
      try {
        if (this.isInitialLoading) {
          this.isInitialLoading = true;
        } else {
          this.loading = true;
        }

        const data = await studentsProvider.getStudents(this.classroom_id, true);
        this.studentList = data.students || [];
        this.payments = data.payments || [];
        this.classroom = data.classroom || {};
        this.gradeCode = this.classroom.grade_code || "";
        this.classNumber = this.classroom.number || "";
        this.refreshKey++;
      } catch (error) {
        console.error(error);
      } finally {
        this.isInitialLoading = false;
        this.loading = false;
      }
    },

    otherPayment(student) {
      return student.payments.filter((payment) => payment.is_other_payment);
    },

    regularPayments(student) {
      // Un élève inscrit avant qu'un groupe de paiement soit appliqué n'a pas
      // de tableau `payments` : on renvoie une liste vide plutôt que de lever
      // une erreur. Aucune pastille ne s'affiche alors sur sa ligne, ce qui
      // traduit exactement l'absence de situation financière.
      if (!student || !Array.isArray(student.payments)) return [];
      return student.payments.filter((payment) => !payment.is_other_payment);
    },

    getNoTitle(payment) {
      let title = payment.label ? `${payment.label}\n` : "";
      title += `Montant : ${this.getCurrency()} ${payment.amount.toLocaleString()}\n`;
      return title;
    },

    getPendingTitle(payment) {
      let title = payment.label ? `${payment.label}\n` : "";
      title += `En attente : ${this.getCurrency()} ${payment.amount.toLocaleString()}\n`;
      let splitTotal = 0;
      if (payment.splits && payment.splits.length > 0) {
        payment.splits.forEach((split) => {
          splitTotal += split.amount;
        });
        title += "Montants versés :\n";
        payment.splits.forEach((split, index) => {
          title += `${index + 1}. ${this.getCurrency()} ${split.amount.toLocaleString()} le ${split.on}\n`;
        });
        const remainingAmount = payment.amount - splitTotal;
        title += `Montant restant : ${this.getCurrency()} ${remainingAmount.toLocaleString()}\n`;
      } else {
        title += "Aucun montant versé trouvé.\n";
      }
      return title;
    },

    getSettledTitle(payment) {
      let title = payment.label ? `${payment.label}\n` : "";
      title += `Réglé : ${this.getCurrency()} ${payment.amount.toLocaleString()}\n`;
      if (payment.splits && payment.splits.length > 0) {
        title += "Montants versés :\n";
        payment.splits.forEach((split) => {
          title += `${this.getCurrency()} ${split.amount.toLocaleString()} le ${split.on}\n`;
        });
      } else {
        title += "";
      }
      return title;
    },

    getOverdueTitle(payment) {
      let title = payment.label ? `${payment.label}\n` : "";
      title += `En retard : ${this.getCurrency()} ${payment.amount.toLocaleString()}\n`;
      let splitTotal = 0;
      if (payment.splits && payment.splits.length > 0) {
        payment.splits.forEach((split) => {
          splitTotal += split.amount;
        });
        title += `Montant restant : - ${(payment.amount - splitTotal).toLocaleString()} ${this.getCurrency()}\n`;
        title += "Montants versés :\n";
        payment.splits.forEach((split) => {
          title += `${this.getCurrency()} ${split.amount.toLocaleString()} le ${split.on}\n`;
        });
      } else {
        title += "Aucun montant versé trouvé.\n";
      }
      return title;
    },

    getCurrency() {
      return this.currency_code;
    },

    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    isDueDatePast(dueDate) {
      const today = new Date(this.today);
      const paymentDate = new Date(dueDate);
      return paymentDate < today;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },

    close1() {
      this.show_status = true;
      this.show_sendmessage = false;
      this.showConfirmation = false;
      this.refreshComponentData();
    },

    getSettledStudents() {
      return studentsProvider.getSettledStudents(this.classroom_id);
    },

    hideModal() {
      this.loading = true;
      this.showOverlay = false;
      setTimeout(() => {
        this.loading = false;
        window.location.reload(true);
      }, 1000);
    },
    getPendingStudents() {
      return studentsProvider.getPendingStudents(this.classroom_id);
    },
    updatePendingStudents() {
      this.studentsPending = this.getPendingStudents().map((student) => ({
        registration_number: student.registration_number,
        current_payment: student.current_payment,
      }));
    },

    setSelectedInstallment(installment) {
      this.selectedInstallment = installment;
      this.label = installment.label;
      this.amount = installment.amount;
      this.due_date = installment.due_date;
      this.installmentNumber = installment.number;
    },

    openmodal(installment, installmentId) {
      this.selectedInstallmentId = null;
      if (installment) {
        this.no_select_installment = false;
        this.show_modal_installments = true;
        this.setSelectedInstallment(installment);
        this.selectedInstallmentId = installment.id || installmentId;
      } else {
        console.error("L'objet 'installment' est undefined");
      }
    },

    setSelectedPayment(payment) {
      this.selectedPayment = payment;
      this.paymentDescription = payment.description;
      this.paymentAmount = payment.amount;
      this.paymentDate = payment.due_date;
      this.paymentId = payment.id;
    },

    openPaymentModal(payment, paymentId) {
      this.selectedPaymentId = null;
      if (payment) {
        this.noSelectPayment = false;
        this.showModalPayments = true;
        this.setSelectedPayment(payment);
        this.selectedPaymentId = payment.id || paymentId;
      } else {
        console.error("L'objet 'payment' est undefined");
      }
    },

    onInstallmentChange() {
      if (this.selectedInstallment) {
        const { amount, due_date, label } = this.selectedInstallment;
        this.label = label;
        this.amount = amount;
        this.due_date = due_date;
      }
    },

    toggleSelectAll() {
      const selectedStudentIds = [];
      let allSelected = true;
      this.Students.forEach((student) => {
        student.selected = this.selectAll;
        if (this.selectAll) {
          selectedStudentIds.push(student.registration_number);
        } else {
          if (!student.selected) {
            allSelected = false;
            this.selectAll = false;
          }
        }
      });
      this.selectAll = allSelected;
      this.isDropdownVisible = this.selectAll;
      this.registration_number_list = selectedStudentIds;
    },

    onCheckboxChange() {
      const selectedStudents = this.Students.filter(
        (student) => student.selected
      );
      const selectedStudentIds = selectedStudents.map(
        (student) => student.registration_number
      );
      this.registration_number_list = selectedStudentIds;
      this.selectAll = selectedStudentIds.length === this.Students.length;
      this.isDropdownVisible = selectedStudents.length > 0;
    },

    refreshComponentData() {
      this.refreshKey++;
      this.isInitialLoading = false; // S'assurer que c'est false pour les actualisations
      this.fetchData();
    },

    getSelectedStudentName() {
      try {
        if (this.registration_number_list && this.registration_number_list.length === 1) {
          const reg = this.registration_number_list[0];
          const s = this.Students.find((st) => st.registration_number === reg || String(st.registration_number) === String(reg));
          if (s) return `${s.first_name || ''} ${s.last_name || ''}`.trim();
        }
      } catch (err) {
        console.error('Failed to get selected student name', err);
      }
      return '';
    },

    // =================== Changer le statut via studentsProvider ===================
    async updatestudentstatut() {
      try {
        this.loading = true;
        this.button = "disabled";
        let registrationNumbers = this.registration_number_list;
        let classroomId = this.classroom_id;
        let status = this.selectedStatus;
        let installmentId = this.selectedInstallmentId;

        if (
          !registrationNumbers ||
          registrationNumbers.length === 0 ||
          !classroomId
        ) {
          this.required = "required";
          this.button = "";
        } else {
              // First try: create payments and set status server-side
              try {
                const createRes = await createAndSetPaymentStatus({
                  installment_id: installmentId,
                  registration_number_list: registrationNumbers,
                });
                if (createRes.status === 200 || createRes.status === 201) {
                  this.show_status = false;
                  this.show_sendmessage = true;
                  this.refreshComponentData();
                  this.button = "";
                  return;
                }
                // otherwise fall through to the existing update mechanism
              } catch (err) {
                console.warn('createAndSetPaymentStatus failed, falling back to updateStudentStatus', err);
              }

              let res = await studentsProvider.updateStudentStatus(
                classroomId,
                registrationNumbers,
                status,
                installmentId
              );
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            this.show_status = false;
            this.show_sendmessage = true;
            this.refreshComponentData();
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la mise à jour du statut", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async updatestatutsettled() {
      try {
        this.loading = true;
        this.button = "disabled";
        let registrationNumbers = this.registration_number_list;
        let classroomId = this.classroom_id;
        let status = this.selectedStatussettled;
        let installmentId = this.selectedInstallmentId;

        if (
          !registrationNumbers ||
          registrationNumbers.length === 0 ||
          !classroomId
        ) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await studentsProvider.updateStudentStatus(
            classroomId,
            registrationNumbers,
            status,
            installmentId
          );
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            this.show_status = false;
            this.show_sendmessage = false;
            this.showConfirmation = true;
            this.refreshComponentData();
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la mise à jour du statut", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async applyothersettled() {
      try {
        this.loading = true;
        this.button = "disabled";
        let registrationNumbers = this.registration_number_list;
        let classroomId = this.classroom_id;
        let status = this.selectedStatussettled;
        let subscriptionId = this.paymentId;

        if (
          !registrationNumbers ||
          registrationNumbers.length === 0 ||
          !classroomId
        ) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await studentsProvider.updateOtherPaymentStatus(
            classroomId,
            registrationNumbers,
            status,
            subscriptionId
          );
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            this.show_status = false;
            this.show_sendmessage = false;
            this.showConfirmation = true;
            this.refreshComponentData();
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la mise à jour du statut", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async applyotherstatut() {
      try {
        this.loading = true;
        this.button = "disabled";
        let registrationNumbers = this.registration_number_list;
        let classroomId = this.classroom_id;
        let status = this.selectedStatus;
        let subscriptionId = this.paymentId;

        if (
          !registrationNumbers ||
          registrationNumbers.length === 0 ||
          !classroomId
        ) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await studentsProvider.updateOtherPaymentStatus(
            classroomId,
            registrationNumbers,
            status,
            subscriptionId
          );
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            this.show_status = false;
            this.show_sendmessage = true;
            this.showConfirmation = false;
            this.refreshComponentData();
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la mise à jour du statut", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async sendinvoice() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.button = "disabled";
        // /api/send_invoices n'attend que les élèves concernés et
        // l'établissement : la tranche a déjà été fixée à l'étape précédente
        // (create_and_set_payment_status), la renvoyer ici est inutile.
        let data = {
          registration_number_list: this.registration_number_list,
          school_slug: this.school_slug,
        };
        if (
          this.registration_number_list === "" ||
          this.registration_number_list === null ||
          this.school_slug === "" ||
          this.school_slug === null
        ) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await sendinvoice(data);
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            const message = this.$t("message.send_invoice");
            toast.success(message, {
              autoClose: 3000,
            });
            setTimeout(() => {
              this.refreshComponentData();
            }, 3000);
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'envoi de la facture", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async sendinvoiceother() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.button = "disabled";
        let data = {
          registration_number_list: this.registration_number_list,
          school_slug: this.school_slug,
          installment_id: this.selectedPaymentId,
        };
        if (
          this.registration_number_list === "" ||
          this.registration_number_list === null ||
          this.school_slug === "" ||
          this.school_slug === null
        ) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await sendinvoice(data);
          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            const message = this.$t("message.send_invoice");
            toast.success(message, {
              autoClose: 3000,
            });
            setTimeout(() => {
              this.refreshComponentData();
            }, 3000);
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'envoi de la facture", {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.button = "";
        this.message = true;
      }
    },

    async fetchxpayconnection() {
      const sf_school_id = this.schoolId;
      try {
        this.loading = true;
        let response = await xpayconnection(sf_school_id);
        if (response && response.length > 0) {
          const connection = response[0];
          this.status_code = connection.status_code;
          localStorage.setItem("status_code", this.status_code);
        } else {
          console.error("Invalid response data or empty array:", response);
        }
      } catch (error) {
        console.error("Error during getconnection call:", error);
      } finally {
        this.loading = false;
      }
    },

    exportToExcel() {
      try {
        const exportData = this.Students.map((student) => {
          // Gestion des numéros de téléphone (phone_list peut être stringifié ou tableau)
          let phoneNumbers = '';
          if (student.phone_list) {
            try {
              let parsed = student.phone_list;
              if (typeof parsed === 'string') {
                parsed = parsed.replace(/'/g, '"').replace(/True/g, 'true').replace(/False/g, 'false');
                parsed = JSON.parse(parsed);
              }
              if (Array.isArray(parsed)) {
                phoneNumbers = parsed.map(p => p.number || p).join(', ');
              }
            } catch (e) {
              phoneNumbers = student.phone_list;
            }
          } else if (student.parent_phone_number) {
            phoneNumbers = student.parent_phone_number;
          } else if (student.parent_phone) {
            phoneNumbers = student.parent_phone;
          } else if (student.parent1_phone) {
            phoneNumbers = student.parent1_phone;
          }

          /*
           * Les deux colonnes de noms passent par les accesseurs : dans les
           * données, le nom de famille est dans `first_name` et le prénom dans
           * `last_name` (voir utils/studentName). Les lire à l'envers mettait
           * le prénom sous l'en-tête « Nom de famille », et inversement.
           */
          return {
            Matricule: student.registration_number || '',
            'Nom de famille': familyNameOf(student),
            Prénom: givenNameOf(student),
            Sexe: student.gender || '',
            'Lieu de naissance': student.pob || '',
            'Date de naissance': student.dob || '',
            'Téléphone parent(s)': phoneNumbers,
          };
        });

        // Créer la feuille Excel
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Élèves');

        // Télécharger le fichier
        XLSX.writeFile(workbook, 'liste_eleves.xlsx');
      } catch (error) {
        console.error('Erreur lors de l’exportation Excel :', error);
        toast.error('Erreur lors de l’exportation Excel', { autoClose: 3000 });
      }
    },
  },

  props: {
    otherPayments: {
      type: Array,
      default: () => [],
    },
    configInstallments: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    const paymentConfigApplied = localStorage.getItem("paymentConfigApplied");
    if (paymentConfigApplied === "true") {
      this.showOverlay = false;
    }
    this.currentDate = new Date().toISOString().slice(0, 10);
  },
};
</script>

<style scoped>
/* ------------------------------------------------------------------
   Effectifs par âge
   ------------------------------------------------------------------ */
.age-breakdown {
  position: absolute;
  right: 500px;
  top: -4px;
  z-index: 3;
}

/*
  Même gabarit que les boutons Alertes et Élèves, dont il partage la ligne :
  ceux-ci tiennent le leur de la règle `#btn-alerte`, qu'on ne peut pas
  partager sans dupliquer un identifiant dans la page — d'où les mêmes
  valeurs reprises sous une classe.
*/
.btn-age-breakdown {
  position: relative;
  width: 200px;
  height: 50px;
  padding: 0px 14px 0;
  justify-content: space-between;
  border: none;
  font-size: 14px;
  white-space: nowrap;
}

/*
  Le bouton ne bouge pas au survol. Le thème applique
  `transform: translateY(-1px)` à tout `.btn` survolé ; sélecteur doublé
  (`.btn.btn-age-breakdown`) pour passer devant sa règle, car à spécificité
  égale c'est l'ordre d'injection des feuilles qui tranche, et il n'est pas
  garanti.
*/
.btn.btn-age-breakdown,
.btn.btn-age-breakdown:hover,
.btn.btn-age-breakdown:focus,
.btn.btn-age-breakdown:active,
.btn.btn-age-breakdown:active:hover {
  transform: none;
}





/* Le thème Argon applique en permanence l'animation `hide-navbar-dropdown`
   (opacity 1 -> 0) sur .dropdown .dropdown-menu, qui est en display: block.
   Quand un dropdown est monté par v-if (ex. en cochant un eleve, ce qui rend
   visibles les boutons "Selectionner tranche" / "Promouvoir"), cette animation
   se rejoue depuis le debut : le menu clignote comme s'il s'ouvrait puis se
   refermait. On neutralise l'animation tant que le menu n'a pas la classe
   .show ajoutee par Bootstrap. */
.dropdown .dropdown-menu:not(.show) {
  animation: none;
  opacity: 0;
  visibility: hidden;
}

.main {
  position: relative;
  height: 100%;
}

#avatar {
  width: 50px; /* Match image dimensions */
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  transition: 300ms ease;
}

#avatar img {
  object-fit: cover;
  object-position: top;
  border-radius: inherit;
  user-select: none;
  pointer-events: none;
}

.custom-select {
  position: relative;
}

.tabble-buttun {
  height: 40px;
  margin-top: 20px;
}

.tabble-buttun span i {
  font-size: 18px;
  cursor: pointer;
  transform: translateY(10px);
}

.table thead tr th {
  width: 150px;
}

.else .image1 {
  width: 200px;
}

.modal2 {
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  width: 100%;
  height: 120%;
  z-index: 100;
  left: 0;
  top: -100px;
  display: none;
}

.modal-active2 {
  display: block;
  /* Styles spécifiques pour afficher la modale */
}

.modal2 .modal-content {
  width: 70%;
  margin-left: 13%;
  margin-right: auto;
  text-align: center;
  background: none;
}

.modal2 .modal-content .card {
  padding-top: 5%;
  margin-top: 15%;
}

.modal2 .modal-content .card .card-body p {
  margin-top: 10%;
  font-size: 20px;
}

.pagination {
  display: flex;
  transform: translateY(-40px);
}

.pagination button {
  margin: 0 5px;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  margin-left: 20px;
}

.pagination button:hover {
  font-weight: 900;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/*---================ filter ========-------*/

#filter {
  width: max-content;
  margin-top: 30px;
  margin-left: auto;
  transform: translateX(-70px);
  z-index: 100;
}

#filter .dropdown {
  position: relative;
  transform: translateX(73px);
  margin-top: -30px;
}

#filter .dropdown .dropdown-menu {
  width: 250px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0;
  border-radius: 0;
  transform: translateY(50px);
}

#filter .dropdown .dropdown-menu li {
  padding: 10px 20px;
  width: auto;
  color: white;
}

#filter .dropdown .icon-filter {
  transform: translateX(-10px);
  font-weight: bold;
}

#filter .dropdown .dropdown-menu .li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.3s;
}
.center-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* ou la largeur souhaitée */
  margin: 0 auto;
  position: relative;
  top: 40px;
}
#filter .dropdown .dropdown-menu li:hover {
  background: rgba(255, 255, 255, 0.1);
}

#filter .dropdown .btn {
  width: 280px;
  margin-top: -60px;
  font-size: 14px;
  font-weight: bold;
}

#see {
  text-align: center;
  width: max-content;
}

#see .cicle {
  margin-left: auto;
  margin-right: auto;
}

#see .span {
  content: "";
  display: block;
  background: #858585;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  border: 2px solid #b8b6b6;
}

#see .span1 {
  content: "";
  display: block;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  border: 2px solid #6cf7d9;
}

#see .span-declarative {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

#see .span-declarative:hover {
  transform: scale(1.35);
  box-shadow: 0 0 0 3px rgba(251, 136, 64, 0.25);
}

#see .span2 {
  content: "";
  display: block;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  border: 2px solid #f7a066;
}

#see .span3 {
  content: "";
  display: block;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  border: 2px solid #ffa0a0;
}

#stat-null,
#stat-settled,
#stat-pending {
  content: "";
  display: block;
  height: 15px;
  width: 15px;
  border-radius: 5px;
  transform: translateY(6px);
}

#stat-null {
  background: #858585;
}

#separateur {
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  text-align: center;
  width: 100%;
}

.li-alert:hover {
  background: white;
  color: black;
  opacity: 0.8;
}

.icon-alert {
  color: black;
  padding: 1px 4px;
  border-radius: 50%;
}

.icon-alert-dash {
  background: #1a98ff;
  color: black;
  padding-bottom: 20px;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  position: absolute;
  bottom: 3px;
  left: 36px;
}

.icon-alert-dash i {
  font-size: 10px;
  position: absolute;
  margin-top: 2px;
  margin-left: 5px;
  color: white;
}

.image-studdents {
  position: relative;
}

.image-studdents .icon-alert {
  position: absolute;

  opacity: 0.9;
  left: 25px;
  bottom: 0px;
  height: 20px;
  width: 20px;
}

.image-studdents .icon-alert i {
  font-size: 13px;
}

#tr-alert {
  transition: 0.3s ease;
  position: relative;
}

.toggle-alert {
  right: 10px;
  top: 40px;
  display: none;
  transition: 0.5s;
  position: absolute;
  width: max-content;
}

#tr-alert:hover .toggle-alert {
  display: block;
  transform: translateY(-30px);
}

.toggle-alert i {
  background: white;
  color: black;
  border-radius: 50%;
  padding: 1px 4px;
}

.icon-alert-legend {
  background: #1a98ff;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  margin-top: 2px;
  padding-left: 5px;
  position: relative;
}

.icon-alert-legend i {
  font-size: 10px;
  position: absolute;
  top: 2px;
  left: 5px;
}

.dropdown-wrapper {
  position: relative;
}

.dropdown-menu-custom {
  position: absolute;
  top: 50%;
  /* Centre verticalement */
  right: 100%;
  /* Place à gauche de l'icône */
  transform: translateY(-50%);
  /* Ajuste le centrage vertical */
  background: #344767;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 0;
  margin-right: 5px;
  /* Espace entre l'icône et le menu */
  list-style: none;
  min-width: 200px;
  z-index: 2000;
}

/* Flèche pointant vers la droite */
.dropdown-menu-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #344767;
}

.dropdown-item-custom {
  padding: 10px 15px;
  text-align: left;
  color: white;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.3s;
  z-index: 1000;
}

.dropdown-item-custom:hover {
  background: rgba(255, 255, 255, 0.1);
}

.dropdown-item-custom i {
  margin-right: 10px;
}
.dropdown-menu {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0px;
  background: #111c45;
}

.dropdown-menu .dropdown-item {
  height: 45px;
  color: white;
  padding-left: 10px;
  padding-top: 12px;
  transition: 0.4s;
  min-width: 230px;
  cursor: pointer;
  border-bottom: 1px solid rgba(250, 250, 250, 0.1);
  transition: background-color 0.3s ease;
}
.dropdown-menu .dropdown-item:hover {
  color: black;
}
#btn-alerte {
  width: 200px;
  height: 50px;
  transform: translateY(-20px);
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
